// External Dependencies
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import transitions from 'material-ui/styles/transitions';
import {
  deepOrange700,
  grey100,
  lightBlack, minBlack,
  white,
} from 'material-ui/styles/colors';

// Local Variables
const rootStyles = {
  position: 'relative',
};

const activeStyles = {
  backgroundColor: grey100,
  color: deepOrange700,
  zIndex: 1,
};

const hoveredStyles = {
  backgroundColor: '#E6E6E6',
  zIndex: 2,
  transition: 'none',
};

const countStyles = {
  backgroundColor: 'rgba(0, 0, 0, 0.08)',
  borderRadius: 12,
  fontSize: 14,
  lineHeight: '24px',
  marginLeft: 12,
  marginTop: 12,
  padding: '0 8px',
  transition: transitions.easeOut('450ms', 'background-color'),
};

const countStylesZero = {
  ...countStyles,
  color: minBlack,
};

const countStylesActive = {
  ...countStyles,
  backgroundColor: deepOrange700,
  color: white,
};

const primaryTextStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const leftProgressContainerStyles = {
  height: 24,
  lineHeight: 1,
  width: 24,
};

const iconButtonStyles = {
  height: 'initial',
  width: 'initial',
  transform: 'translate(-12px, -12px)',
};

const leftProgressElement = (
  <div style={leftProgressContainerStyles}>
    <CircularProgress size={24} />
  </div>
);

// Component Definition
class EnhancedMenuItem extends Component {
  static propTypes = {
    count: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    icon: PropTypes.func,
    iconColor: PropTypes.string,
    iconTooltip: PropTypes.string,
    icons: PropTypes.arrayOf(PropTypes.element),
    isActive: PropTypes.bool,
    isLoading: PropTypes.bool,
    // Styles
    style: PropTypes.shape({}),
    text: PropTypes.node.isRequired,
  }

  static defaultProps = {
    count: null,
    icon: null,
    iconColor: lightBlack,
    iconTooltip: null,
    icons: [],
    isActive: false,
    isLoading: false,
    // Styles
    style: {},
  }

  state = {
    isHovered: false,
  }

  handleMouseEnter = () => this.setState({ isHovered: true });
  handleMouseLeave = () => this.setState({ isHovered: false });

  render() {
    const {
      count,
      icon: Icon,
      iconColor,
      iconTooltip,
      icons,
      isActive,
      isLoading,
      style,
      text,
      ...other
    } = this.props;

    const {
      isHovered,
    } = this.state;

    const hasCount = (typeof count === 'number' && Number.isInteger(count))
      || (typeof count === 'string' && count.length);

    let leftIcon;
    if (Icon) {
      if (!hasCount && isLoading) {
        leftIcon = leftProgressElement;
      } else {
        leftIcon = (
          <IconButton
            style={iconButtonStyles}
            tooltip={iconTooltip}
            tooltipPosition="bottom-right"
          >
            <Icon color={iconColor || lightBlack} />
          </IconButton>
        );
      }
    }

    let secondaryElement;
    if (hasCount) {
      let countStyle;
      if (isActive) countStyle = countStylesActive;
      else if (count === 0) countStyle = countStylesZero;
      else countStyle = countStyles;

      const prettyCount = Number.isInteger(count)
        ? count.toLocaleString()
        : count;
      secondaryElement = <span style={countStyle}>{prettyCount}</span>;
    }

    let menuItemRootStyle = {};
    if (isHovered) menuItemRootStyle = { ...menuItemRootStyle, ...hoveredStyles };
    else if (isActive) {
      menuItemRootStyle = { ...menuItemRootStyle, ...activeStyles };
    }
    menuItemRootStyle = { ...menuItemRootStyle, ...style };

    return (
      <div style={rootStyles}>
        <MenuItem
          {...other}
          leftIcon={leftIcon}
          onFocus={icons && this.handleMouseEnter}
          onMouseEnter={icons && this.handleMouseEnter}
          onMouseLeave={icons && this.handleMouseLeave}
          onMouseOver={icons && this.handleMouseEnter}
          primaryText={<div style={primaryTextStyles}>{text}</div>}
          secondaryText={secondaryElement}
          style={menuItemRootStyle}
        />
      </div>
    );
  }
}

export default EnhancedMenuItem;



/** WEBPACK FOOTER **
 ** ./src/shared/enhanced-menu-item/index.js
 **/